import React from 'react';
import PropTypes from 'prop-types';

function IconPause({ className }) {
  return (
    <svg width="32" height="20" viewBox="0 0 32 20" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="20" rx="2" fill="#383838"/>
      <path d="M17.8 5H20.5V15H17.8V5Z" fill="#01FF95"/>
      <path d="M11.5 5H14.2V15H11.5V5Z" fill="#01FF95"/>
    </svg>
  )
}

IconPause.propTypes = {
  className: PropTypes.string
}

export default IconPause;
